import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';

function PublicLayout() {
  const [showSidebar, setShowSidebar] = useState(false);

  const handleCloseSidebar = () => setShowSidebar(false);
  const handleShowSidebar = () => setShowSidebar(true);

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Header */}
      <Header onMenuClick={handleShowSidebar} />
      
      {/* Sidebar */}
      <Sidebar 
        show={showSidebar} 
        handleClose={handleCloseSidebar}
      />
      
      {/* Main Content */}
      <main className="flex-grow-1">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default PublicLayout; 